import { render, staticRenderFns } from "./AgeComponent.vue?vue&type=template&id=4e31fe2a"
import script from "./AgeComponent.vue?vue&type=script&lang=js"
export * from "./AgeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports